import { render, staticRenderFns } from "./GoodCate.vue?vue&type=template&id=0539bda9&"
import script from "./GoodCate.vue?vue&type=script&lang=js&"
export * from "./GoodCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports